function isDevEnv(devEnvs = ['local', 'test', 'stage']) {
  return (
    process.env.REACT_APP_ENV && devEnvs.includes(process.env.REACT_APP_ENV)
  );
}

export default isDevEnv;
